import { render, staticRenderFns } from "./JudgesManagement.vue?vue&type=template&id=52d49650&scoped=true&"
import script from "./JudgesManagement.vue?vue&type=script&lang=js&"
export * from "./JudgesManagement.vue?vue&type=script&lang=js&"
import style0 from "./JudgesManagement.vue?vue&type=style&index=0&id=52d49650&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d49650",
  null
  
)

export default component.exports